module.exports = __webpack_public_path__ + "c362b0248ae484b4f7c15d25c5e06cc6.png";